import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Collection, Feature } from 'ol';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { FeatureType } from '../models/EnumTypes';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { ToolsControlService } from './tools-control.service';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { UtilsService } from './utils.service';
import {ProcedureModel } from '../models/procedure';
import { CoordinatePointModel } from '../models/coordinate-point';
import { ProcedureControlService } from './procedure-control.service';
import { ModalControlService } from './modal-control.service';
import {cloneDeep, first } from 'lodash';
import { ProcedureCoordinatePointModel } from '../models/procedure-coordinate-point';
import { ProcedureLegModel, ProcedurePath } from '../models/procedure-leg';
import * as olProj from 'ol/proj';
import { SelectCoordinatePointsControlService } from '../popup/services/select-coordinate-points-control.service';
import { MapService } from './map.service';
import LineString from 'ol/geom/LineString';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { coordinatePointTransformationOffsetResult } from '../models/coordinatePointTransformationOffsetResult';
import olMap from 'ol/Map';
import { Modify, Select } from 'ol/interaction';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import {unByKey} from 'ol/Observable';
import { SearchItem } from '../models/searchItem';
import { SearchService } from './search.service';
import { Coordinate } from 'ol/coordinate';
//import { toJSDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';
import { CalculationValidation } from './calculation-validation.service';
import { offset } from 'ol/sphere';
import { CoordinatesService } from './coordinates.service';
import { CoordenateService } from './coordenate.service';
import { CoordinatePointsService } from './coordinate-points.service';
import { firstValueFrom } from 'rxjs';
import VectorSource from 'ol/source/Vector';
import { Geometry, MultiPoint } from 'ol/geom';



@Injectable({
  providedIn: 'root'
})
export class ProcedureAssessmentsService {

  active : boolean;
  fullScreenMode : boolean = false;
  selectedProcedure: ProcedureModel;
  offsetProcedure: ProcedureModel;
  originalProcedure: ProcedureModel;
  selectedAirport: CoordinatePointModel = undefined;
  procedurePaths: ProcedurePath[] = undefined;
  map: olMap;
  dragInteraction: Modify;
  isResetPosition: boolean = false;
  eventKey = null;
  loading: boolean = false;
  procedureInterfaceToHTML: ProcedureModel;
  numberOfLegsCut: number = 0;
  procedureHasChanged: boolean;
  fixPoints: ProcedureCoordinatePointModel[];
  legsNextToCurve : ProcedureLegModel[];
  originalFixPoints: ProcedureCoordinatePointModel[];
  procedure : Feature;
  changeOriginal :  boolean = false;
  constructor( private projectService : ProjectService,
    private popupService : BsModalService,
    public bsModalRef : BsModalRef,
    private http: HttpClient,
    private endpointService: EndpointsService,
    private globalSelectionService : GlobalSelectionControlService,
    private utilsService : UtilsService,
    private toolsService: ToolsControlService,
    public pointsService : PointsService,
    public procedureController : ProcedureControlService,
    private modalService : ModalControlService,
    public selectCoordinatePointService : SelectCoordinatePointsControlService,
    public mapService : MapService,
    public rcsControl: CoordenateService,
    public coordinatePointsService: CoordinatePointsService

  ) {
    this.selectedProcedure = new ProcedureModel();
    this.originalProcedure = new ProcedureModel();
    this.procedureInterfaceToHTML =  new ProcedureModel();
    this.fixPoints = [];
    this.legsNextToCurve = [];
    this.map = this.mapService.getMap('map');

  }

  /*
  openWindow() {
    this.clearVariables();

    if (this.verifyProcedure()) {
      this.active = true;
      this.toolsService.navigationOnTop = true;

      this.addProcedureToMapAndModal();

    }

  }*/
  openFooter(){
    this.active = true;
  }
  addProcedureToMapAndModal(addToMap:boolean = true){

    this.selectedProcedure.procedureid = `${this.originalProcedure.proceduretype}_assmentTempProcedure|${this.originalProcedure.procedureid}`;
    this.selectedProcedure.proceduretype = "ASSESSMENT";

    this.procedurePaths = new Array<ProcedurePath>();
    if(addToMap){
      this.selectedProcedure.procedureLegs.forEach(leg => {
        leg.offset = 0.0;
        leg.direction = "NotSet";

      });
      this.pointsService.addProcedureToMap(this.selectedProcedure);
    }

    this.procedureInterfaceToHTML = cloneDeep(this.selectedProcedure);
    this.selectCoordinatePointService.selectedProcedure = this.selectedProcedure;
   // this.procedureController.addProcedureLegsToMap(this.selectedProcedure);
    let sequenceNumber = 0;
    for (let i = 0; i < this.procedureInterfaceToHTML.procedureLegs.length; i++){
      if (this.procedureInterfaceToHTML.procedureLegs[i].fixPoint != null){
        this.procedureInterfaceToHTML.procedureLegs[i].fixPoint.sequencenumber = sequenceNumber;
        sequenceNumber++;
        this.fixPoints.push(this.procedureInterfaceToHTML.procedureLegs[i].fixPoint);
        if (i - 1 >= 0){
          this.pushIfNotIncluded(this.procedureInterfaceToHTML.procedureLegs[i - 1], this.legsNextToCurve);
          this.procedureInterfaceToHTML.procedureLegs[i - 1].ismodified = true;
        }
        this.pushIfNotIncluded(this.procedureInterfaceToHTML.procedureLegs[i], this.legsNextToCurve);
        this.procedureInterfaceToHTML.procedureLegs[i].ismodified = true;
        if (i + 1 < this.procedureInterfaceToHTML.procedureLegs.length){
          this.pushIfNotIncluded(this.procedureInterfaceToHTML.procedureLegs[i + 1], this.legsNextToCurve);
          this.procedureInterfaceToHTML.procedureLegs[i + 1].ismodified = true;
        }
      }
    }
    this.originalFixPoints = cloneDeep(this.fixPoints);


  }

  private pushIfNotIncluded(toPush: any, array: any[]) : void{
    if (!array.includes(toPush)){
      array.push(toPush);
    }
  }

  setPointer(isOnFocus?: boolean){
    this.setPointerForProcedureAssessment(this.selectedProcedure, isOnFocus);
  }
  switchFooter(){
    this.active = false;
    this.removeInteractions();
    this.clearVariables();
  }
  restoreMapAndClearVariables(procedureModel?: ProcedureModel){
    if(!procedureModel){
      procedureModel= this.selectedProcedure;
      this.clearVariables();
    }


    this.deleteProcedureAssessmentLegsOnMap(procedureModel.id);
    this.pointsService.deleteCoordinatePointsFromMap();

    this.pointsService.fetchAndAddCoordinatePoints();
  }

  deleteProcedureAssessmentLegsOnMap(procedureId: number, ){
    const assessmentSource = this.globalSelectionService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();
    let assessmentSOffsetource = this.globalSelectionService.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();
    
    assessmentSource.getFeatures().forEach( feat =>{
      if(procedureId == feat.getProperties().id){
          assessmentSource.removeFeature(feat);
      }
    });

    assessmentSOffsetource.getFeatures().forEach( feat =>{
      if(procedureId == feat.getProperties().id){
          assessmentSOffsetource.removeFeature(feat);
      }
    });
  }
  clearProcedureAssessment(): void {
    this.active = false;
    this.removeInteractions();

    this.restoreMapAndClearVariables();
  }

  public clearVariables(){
    this.fixPoints = [];
    this.originalFixPoints = undefined;
    this.legsNextToCurve = [];
    this.selectedProcedure = new ProcedureModel();
    this.originalProcedure = new ProcedureModel();
    this.procedureInterfaceToHTML =  new ProcedureModel();
  }

  clearAssessmentLayer():void {
    this.selectCoordinatePointService.getLayerSourceFromProcedureType(this.selectedProcedure.proceduretype).clear();
  }

  setPointerForProcedureAssessment(procedure: ProcedureModel, isOnFocus?: boolean){
    if (!isOnFocus){
      this.globalSelectionService.clearAllSelected();
    }
    this.mapService.clearSelections();
    this.globalSelectionService.coordinatePointsLayers.layersSelector.pointer=true;
    let layersArr2 = [];

    this.globalSelectionService.coordinatePointsLayers.childLayers.forEach(chlid => {
      chlid.layers.forEach(layer => layersArr2.push(layer.olLayer));
    });

    this.globalSelectionService.navaidsLayers.childLayers.forEach(chlid => {
      chlid.layers.forEach(layer => layersArr2.push(layer.olLayer));
    });


    var thisObject = this;
    var coordinateFeatureType = FeatureType.CoordinatePoint;
    this.mapService.select = new Select({
      style:null,
      //train wreck anti pattern....
      layers: layersArr2,
      hitTolerance: 5,
      filter: function(feature) {
        const featureExist = thisObject.procedureInterfaceToHTML.procedureCoordinatePoints.find(element =>
        element.coordPoint.id === feature.getProperties().id)
        const fixPoint = thisObject.fixPoints.find(element => element.coordPoint.id === feature.getProperties().id)
        return (featureExist != undefined || fixPoint != undefined || feature.getProperties().featureType != coordinateFeatureType) && 
                !(feature.getGeometry() instanceof MultiPoint);
      }
    })

    this.mapService.select.on('select', function(event){
      if(event.selected.length > 0){
        if (thisObject.eventKey != null){
          unByKey(thisObject.eventKey);
        }
        if (thisObject.dragInteraction != null){
          thisObject.map.removeInteraction(thisObject.dragInteraction);
        }
        var layer = thisObject.mapService.select.getLayer(event.selected[0]) as unknown as VectorLayerDMTR;
        thisObject.globalSelectionService.setSelectedFeature(layer, event.selected[0]);
        let pointBelongsToCurveLeg = false;
        for (const leg of thisObject.legsNextToCurve){
          if (event.selected[0].getProperties().id == leg.startPoint.coordPoint.id ||
            event.selected[0].getProperties().id == leg.endPoint.coordPoint.id) {
              pointBelongsToCurveLeg = true;
          }
        }
        if (event.selected[0].getProperties().featureType == coordinateFeatureType && !pointBelongsToCurveLeg){
          thisObject.dragInteraction = new Modify({
            features: new Collection([event.selected[0]]),
            style: null
          });
          thisObject.map.addInteraction(thisObject.dragInteraction);
          thisObject.eventKey = thisObject.dragInteraction.on('modifyend',function(e){
            const feature = e.features.getArray()[0];
            const featureId = feature.getProperties().id;
            const coordPointIndex = procedure.procedureCoordinatePoints.findIndex(cp => cp.coordPoint.id === featureId);
            const geometry = feature.getGeometry() as import('ol/geom').Point;
            const coordPointCoordinates = olProj.toLonLat(geometry.getCoordinates(), thisObject.rcsControl.activeRCS.isactive ? thisObject.rcsControl.activeRCS.epsg : "EPSG:3857");
            if (coordPointIndex != -1){
              procedure.procedureCoordinatePoints[coordPointIndex].coordPoint.latitude = coordPointCoordinates[1];
              procedure.procedureCoordinatePoints[coordPointIndex].coordPoint.longitude = coordPointCoordinates[0];
              thisObject.updateProcedure(procedure);
            } else {
              let coordPointInterfaceIndex = thisObject.procedureInterfaceToHTML.procedureCoordinatePoints.findIndex(pcpInterface =>
                pcpInterface.coordPoint.id ==  featureId);
              if (coordPointInterfaceIndex != -1){
                thisObject.procedureInterfaceToHTML.procedureCoordinatePoints[coordPointInterfaceIndex].coordPoint.latitude = Math.round(coordPointCoordinates[1] * 100000) / 100000;
                thisObject.procedureInterfaceToHTML.procedureCoordinatePoints[coordPointInterfaceIndex].coordPoint.longitude = Math.round(coordPointCoordinates[0] * 100000) / 100000;
                thisObject.checkIfChange(thisObject.procedureInterfaceToHTML.procedureCoordinatePoints[coordPointInterfaceIndex].coordPoint, coordPointInterfaceIndex );
              }
            }
            const fixPointIndex = thisObject.fixPoints.findIndex(fixPoint => fixPoint.coordPoint.id === featureId);
            if (fixPointIndex != -1){
              const oldCoordPoint : CoordinatePointModel = cloneDeep(thisObject.fixPoints[fixPointIndex].coordPoint);
              thisObject.updateFixPoint(fixPointIndex, coordPointCoordinates, oldCoordPoint);
            }
          });
        }
      }
      if(event.deselected.length > 0){
        thisObject.globalSelectionService.removeSelectedFeature(event.deselected[0]);
      }
    });
    this.map.addInteraction(this.mapService.select);
  }

  moveCoordinatePoint(coordinatePoint : CoordinatePointModel, latDiff: number, lonDiff: number){
    coordinatePoint.latitude = Math.round((coordinatePoint.latitude + latDiff) * 100000) / 100000;
    coordinatePoint.longitude = Math.round((coordinatePoint.longitude + lonDiff) * 100000) / 100000;
    const source = this.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === coordinatePoint.type.toLowerCase())
      .olLayer.getSource();
    const feature = source.getFeatureById(coordinatePoint.id);
    source.removeFeature(feature);
    feature.setProperties({
      'latitude': coordinatePoint.latitude,
      'longitude': coordinatePoint.longitude
    })
    this.pointsService.addCoordinatePointToMap(this.pointsService.transformFeatureInCoordinatePoint(feature), true);
  }

  updateFixPoint(fixPointIndex: number, coordinate: Coordinate, oldCoordPoint: CoordinatePointModel){
    this.fixPoints[fixPointIndex].coordPoint.latitude = Math.round(coordinate[1] * 100000) / 100000;
    this.fixPoints[fixPointIndex].coordPoint.longitude =  Math.round(coordinate[0] * 100000) / 100000;
    const latDiff = Math.round((this.fixPoints[fixPointIndex].coordPoint.latitude - oldCoordPoint.latitude) * 100000) / 100000;
    const lonDiff = Math.round((this.fixPoints[fixPointIndex].coordPoint.longitude - oldCoordPoint.longitude) * 100000) / 100000;
    const curveLegOrNearCurveIndex = this.legsNextToCurve.findIndex(leg =>  leg.fixPoint != null && leg.fixPoint.coordPoint.id == oldCoordPoint.id);
    let previousLegCurve: boolean = false;
    let nextLegCurve: boolean = false;
    let source = undefined;
    let feature:Feature = undefined;
    let coordinatePoint : CoordinatePointModel = undefined;
    if (curveLegOrNearCurveIndex - 1 >= 0){
      // previous leg
      previousLegCurve = !this.legsNextToCurve[curveLegOrNearCurveIndex-1].isstraightleg;
      if (!previousLegCurve){
        // case move procedure coordinate point (startPoint)
        coordinatePoint = this.selectedProcedure.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id == this.legsNextToCurve[curveLegOrNearCurveIndex-1].startPoint.coordPoint.id).coordPoint;
      } else {
        // case move fix point
        coordinatePoint = this.legsNextToCurve[curveLegOrNearCurveIndex-1].fixPoint.coordPoint;
      }
      this.moveCoordinatePoint(coordinatePoint, latDiff, lonDiff);
    }
    // middle leg
    // move start point
    coordinatePoint = this.selectedProcedure.procedureCoordinatePoints.find(pcp =>
      pcp.coordPoint.id == this.legsNextToCurve[curveLegOrNearCurveIndex].startPoint.coordPoint.id).coordPoint;
    this.moveCoordinatePoint(coordinatePoint, latDiff, lonDiff);
    // move end point
    coordinatePoint = this.selectedProcedure.procedureCoordinatePoints.find(pcp =>
      pcp.coordPoint.id == this.legsNextToCurve[curveLegOrNearCurveIndex].endPoint.coordPoint.id).coordPoint;
    this.moveCoordinatePoint(coordinatePoint, latDiff, lonDiff);
    // move curve points
    this.legsNextToCurve[curveLegOrNearCurveIndex].curvePoints.forEach(curvePoint => {
      curvePoint.latitude += latDiff;
      curvePoint.longitude += lonDiff;
    })
    if (curveLegOrNearCurveIndex + 1 < this.legsNextToCurve.length){
      // next leg
      nextLegCurve = !this.legsNextToCurve[curveLegOrNearCurveIndex+1].isstraightleg;
      if (!nextLegCurve){
        // case move procedure coordinate point (endPoint)
        coordinatePoint = this.selectedProcedure.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id == this.legsNextToCurve[curveLegOrNearCurveIndex+1].endPoint.coordPoint.id).coordPoint;
      } else {
         // case move fix point
        coordinatePoint = this.legsNextToCurve[curveLegOrNearCurveIndex+1].fixPoint.coordPoint;
      }
      this.moveCoordinatePoint(coordinatePoint, latDiff, lonDiff);
    }
    if (previousLegCurve || nextLegCurve){
      this.isResetPosition = true;
    }
    this.updateProcedure(this.selectedProcedure, this.fixPoints[fixPointIndex].coordPoint);
    if (previousLegCurve){
      if (nextLegCurve){
        this.isResetPosition = true;
      }
      this.legsNextToCurve[curveLegOrNearCurveIndex-1].curvePoints = [];
      this.selectCoordinatePointService.calculateCurvePoints(this.legsNextToCurve[curveLegOrNearCurveIndex-1]);
      this.updateProcedure(this.selectedProcedure, this.legsNextToCurve[curveLegOrNearCurveIndex-1].fixPoint.coordPoint);
    }
    if (nextLegCurve){
      this.legsNextToCurve[curveLegOrNearCurveIndex+1].curvePoints = [];
      this.selectCoordinatePointService.calculateCurvePoints(this.legsNextToCurve[curveLegOrNearCurveIndex+1]);
      this.updateProcedure(this.selectedProcedure, this.legsNextToCurve[curveLegOrNearCurveIndex+1].fixPoint.coordPoint);
    }
  }

  updateInterfaceProcedure(){
    this.selectedProcedure.procedureCoordinatePoints.forEach(pcp => {
      let coordPointInterface = this.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcpInterface =>
        pcpInterface.coordPoint.id ==  pcp.coordPoint.id);
        if (coordPointInterface != undefined){
          coordPointInterface.coordPoint.latitude = pcp.coordPoint.latitude;
          coordPointInterface.coordPoint.longitude = pcp.coordPoint.longitude;
          const legStart = this.procedureInterfaceToHTML.procedureLegs.find(leg => leg.startPoint.coordPoint.id == coordPointInterface.coordPoint.id);
          if (legStart != undefined){
            legStart.startPoint.coordPoint.latitude = pcp.coordPoint.latitude;
            legStart.startPoint.coordPoint.longitude = pcp.coordPoint.longitude;
          }
          const legEnd = this.procedureInterfaceToHTML.procedureLegs.find(leg => leg.endPoint.coordPoint.id == coordPointInterface.coordPoint.id);
          if (legEnd != undefined){
            legEnd.endPoint.coordPoint.latitude = pcp.coordPoint.latitude;
            legEnd.endPoint.coordPoint.longitude = pcp.coordPoint.longitude;
          }

        }

    })
    this.procedureController.addProcedureLegsToMap(this.selectedProcedure);
    for (let i = 0; i < this.procedureInterfaceToHTML.procedureCoordinatePoints.length; i++){
      this.checkIfChange(this.procedureInterfaceToHTML.procedureCoordinatePoints[i].coordPoint, i);
    }
    for (let i = 0; i < this.fixPoints.length; i++){
      this.checkIfChange(this.fixPoints[i].coordPoint, i, true);
    }

  }

  async updateProcedure(selectedProcedure: ProcedureModel, fixPoint? : CoordinatePointModel): Promise<void> {
    if (fixPoint){

      const leg = selectedProcedure.procedureLegs.find(leg2 => leg2.fixPoint != null && leg2.fixPoint.coordPoint.id == fixPoint.id);
      leg.fixPoint.coordPoint.latitude = Math.round(fixPoint.latitude * 100000) / 100000;
      leg.fixPoint.coordPoint.longitude = Math.round(fixPoint.longitude * 100000) / 100000;
      const legInterface = this.legsNextToCurve.find(leg2 => leg2.fixPoint != null && leg2.fixPoint.coordPoint.id == fixPoint.id);
      leg.curvePoints = cloneDeep(legInterface.curvePoints);
    }
    let hasOffSet = false;
    // TODO: find more efficient way to code this
    selectedProcedure.procedureCoordinatePoints.forEach(pcp => {
      selectedProcedure.procedureLegs.forEach(leg => {
        pcp.coordPoint.latitude = Math.round(pcp.coordPoint.latitude * 100000) / 100000;
        pcp.coordPoint.longitude = Math.round(pcp.coordPoint.longitude * 100000) / 100000;
        if (leg.startPoint.coordPoint.id === pcp.coordPoint.id) {
          leg.startPoint.coordPoint.latitude = pcp.coordPoint.latitude;
          leg.startPoint.coordPoint.longitude = pcp.coordPoint.longitude;
        }
        if (leg.endPoint.coordPoint.id === pcp.coordPoint.id) {
          leg.endPoint.coordPoint.latitude = pcp.coordPoint.latitude;
          leg.endPoint.coordPoint.longitude = pcp.coordPoint.longitude;
        }
        if (leg.direction != "NotSet" && leg.offset != 0.0 && leg.offset != null && leg.direction != null){
          hasOffSet = true;
        }
      });
    });

    if (!this.isResetPosition){
      this.pointsService.deleteAssessmentProcedureFromMap(selectedProcedure);

      this.pointsService.addProcedureToMap(selectedProcedure);
      if (hasOffSet) {
        await this.pointsService.addProcedureOffSetToMap(selectedProcedure);
      }


    }
    this.updateInterfaceProcedure();
    this.isResetPosition = false;


  }
  initializeProcedureFromFeature(features: Feature[], procedureInterfaceToHTML?: ProcedureModel){
    this.clearVariables();
    let procedureModel: ProcedureModel = null;
    if(features.length == 1){
      this.procedure =features[0];
      procedureModel = this.procedureController.transformFeatureInProcedure(this.procedure);
      this.selectedProcedure = cloneDeep(procedureModel);
    }
    else{
      this.procedure = features.find((feature) => feature.get('proceduretype') != 'ASSESSMENT' && feature.get('proceduretype') != 'assessmentoffset');
      this.selectedProcedure = cloneDeep(procedureInterfaceToHTML);
      procedureModel = this.procedureController.transformFeatureInProcedure(this.procedure);
    }
    this.originalProcedure = cloneDeep(procedureModel);

    this.originalProcedure.procedureCoordinatePoints = cloneDeep(procedureModel.procedureCoordinatePoints);
    this.originalProcedure.procedureLegs = cloneDeep(procedureModel.procedureLegs);
    if(this.selectedProcedure.referenceAirportPk != null) {
      this.pointsService.getCoordinatePoint(this.selectedProcedure.referenceAirportPk).subscribe(
        (data : CoordinatePointModel) => {
          this.selectedAirport = data;
          this.selectedAirport.composedName = data.coordpointid + ' - ' + data.name;
        },
        (error) => {
          console.log(error);
        }
      );
    }
    this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
      child.showAll();
    });
    this.addProcedureToMapAndModal(features.length == 1);
    if (this.procedure != null) {
      this.addCoordinatePointFeatures(procedureModel);
      this.setPointer();
    }

  }


  addCoordinatePointFeatures(procedureModel: ProcedureModel) {
    const features: Feature[] = [];
    for (const coordPoint of procedureModel.procedureCoordinatePoints.map(pcp => pcp.coordPoint)) {
      this.pointsService.addCoordinatePointToMap(coordPoint, true);
      features.push(this.pointsService.createCoordinatePointFeature(coordPoint, null, false));
    }

    for (const fixPoint of procedureModel.procedureLegs.map(leg => leg.fixPoint).filter(fp => fp != null)) {
      this.pointsService.addCoordinatePointToMap(fixPoint.coordPoint, true);
      features.push(this.pointsService.createCoordinatePointFeature(fixPoint.coordPoint, null, false));
    }

    
    this.pointsService.deleteCoordinatePointsFeatures(features);


    // for (const feat of features) {
    //   const layer = this.pointsService.getLayerFromCoordPointType(feat.get("type"));
    //   const color = this.pointsService.getColorOfType('Coordinate Points', layer.id, feat.get("userdefined"));
    //   this.pointsService.setFeatureStyle(feat, layer, color);
    //   layer.olLayer.getSource().addFeature(feat);
    // }
  }

  removeInteractions(): void {
    this.map.removeInteraction(this.mapService.select);
    if (this.eventKey != null){
      unByKey(this.eventKey);
    }
    if (this.dragInteraction != null){
      this.map.removeInteraction(this.dragInteraction);
    }
  }

  redirectProcedure(coordinatePointId: number): void {
    this.removeInteractions();
    let selectedCoordPoint: ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
    const index = this.selectedProcedure.procedureCoordinatePoints.findIndex( coord => coord.coordPoint.id === coordinatePointId );
    selectedCoordPoint = this.selectedProcedure.procedureCoordinatePoints[index];
    this.selectedProcedure.procedureLegs[index - 1].endPointId = this.selectedProcedure.procedureLegs[index].endPointId;
    this.selectedProcedure.procedureLegs[index - 1].endPoint = this.selectedProcedure.procedureLegs[index].endPoint;
    this.selectedProcedure.procedureLegs.splice(index, 1);
    this.selectedProcedure.procedureCoordinatePoints.splice(index, 1);
    if (this.selectedProcedure.procedureCoordinatePoints.length == 1) {
      this.selectedProcedure.procedureCoordinatePoints = [];
    }
    this.setPointer();
    this.updateProcedure(this.selectedProcedure);
  }

  resetProcedureCoordinatePositions() {
    for (let i = 0; i < this.procedureInterfaceToHTML.procedureCoordinatePoints.length; i++){
      this.isResetPosition = true;
      if (i == this.selectedProcedure.procedureCoordinatePoints.length - 1 && this.fixPoints.length == 0){
        this.isResetPosition = false;
      }
      let pcp = this.selectedProcedure.procedureCoordinatePoints.findIndex(pcp => pcp.coordPoint.id == this.procedureInterfaceToHTML.procedureCoordinatePoints[i].coordPoint.id );
      if (i < this.selectedProcedure.procedureCoordinatePoints.length ){
        this.resetEspecificCoordinatePoint(this.selectedProcedure.procedureCoordinatePoints[i].coordPoint.id, this.selectedProcedure);
      }
      if (pcp == -1){
        this.isResetPosition = true;
        this.resetEspecificCoordinatePoint(this.procedureInterfaceToHTML.procedureCoordinatePoints[i].coordPoint.id, this.procedureInterfaceToHTML);
      }

    }
    for (let i = 0; i < this.fixPoints.length; i++){
      if (i < this.fixPoints.length - 1){
        this.isResetPosition = true;
      }
      this.resetEspecificFixPoint(this.fixPoints[i]);
    }
  }

  resetEspecificFixPoint(fixPoint: ProcedureCoordinatePointModel, calculateCurve?: boolean){
    const originalFixPointLeg = this.originalProcedure.procedureLegs.find(leg =>
      leg.fixPoint != null && leg.fixPoint.coordPoint.id == fixPoint.coordPoint.id);
    const realFixPointLeg = this.selectedProcedure.procedureLegs.find(leg =>
      leg.fixPoint != null && leg.fixPoint.coordPoint.id == fixPoint.coordPoint.id);
    const interfaceFixPointLeg = this.legsNextToCurve.find(leg =>
      leg.fixPoint != null && leg.fixPoint.coordPoint.id == fixPoint.coordPoint.id);
    interfaceFixPointLeg.fixPoint.coordPoint.latitude = Math.round(originalFixPointLeg.fixPoint.coordPoint.latitude * 100000) / 100000;
    interfaceFixPointLeg.fixPoint.coordPoint.longitude = Math.round(originalFixPointLeg.fixPoint.coordPoint.longitude * 100000) / 100000;
    realFixPointLeg.fixPoint.coordPoint.latitude = Math.round(originalFixPointLeg.fixPoint.coordPoint.latitude * 100000) / 100000
    realFixPointLeg.fixPoint.coordPoint.longitude = Math.round(originalFixPointLeg.fixPoint.coordPoint.longitude * 100000) / 100000


    let source = this.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === fixPoint.coordPoint.type.toLowerCase())
    .olLayer.getSource();
    let feature:Feature = source.getFeatureById(fixPoint.coordPoint.id);
    source.removeFeature(feature);
    feature.setProperties({
      'latitude': Math.round(fixPoint.coordPoint.latitude * 100000) / 100000,
      'longitude': Math.round(fixPoint.coordPoint.longitude * 100000) / 100000
    })
    this.pointsService.addCoordinatePointToMap(this.pointsService.transformFeatureInCoordinatePoint(feature), true);

    if (calculateCurve){
      interfaceFixPointLeg.curvePoints = [];
      this.selectCoordinatePointService.calculateCurvePoints(interfaceFixPointLeg);
    } else {
      interfaceFixPointLeg.curvePoints = cloneDeep(originalFixPointLeg.curvePoints);
    }

    this.updateProcedure(this.selectedProcedure, fixPoint.coordPoint);

  }

  resetEspecificOffset(coordnatePointId: ProcedureLegModel, isResetAll?: boolean): void {
    coordnatePointId.offset = 0;
    coordnatePointId.direction = "NotSet";
    if (isResetAll){
      this.updateOffset(null, isResetAll);
    }
    this.updateOffset(null);
  }
  resetEspecificCoordinatePoint(coordnatePointId: number, procedure: ProcedureModel): void {
    this.removeInteractions();

    this.pointsService.deleteAssessmentProcedureFromMap(procedure);

    const originalProcIndex = this.originalProcedure.procedureCoordinatePoints.findIndex( (cp) => {
      return cp.coordPoint.id == coordnatePointId;
    });

    const selectedProcIndex  = procedure.procedureCoordinatePoints.findIndex( (cp) => {
      return cp.coordPoint.id == coordnatePointId;
    });

    let pcp = procedure.procedureCoordinatePoints[selectedProcIndex].coordPoint;
    pcp.latitude =  this.originalProcedure.procedureCoordinatePoints[originalProcIndex].coordPoint.latitude;
    pcp.longitude = this.originalProcedure.procedureCoordinatePoints[originalProcIndex].coordPoint.longitude;
    let source = this.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === pcp.type.toLowerCase())
    .olLayer.getSource();
    let feature:Feature = source.getFeatureById(pcp.id);
    source.removeFeature(feature);
    feature.setProperties({
      'latitude': Math.round(pcp.latitude * 100000) / 100000,
      'longitude': Math.round(pcp.longitude * 100000) / 100000
    })
    this.pointsService.addCoordinatePointToMap(this.pointsService.transformFeatureInCoordinatePoint(feature), true);




    this.setPointer();
    this.updateProcedure(this.selectedProcedure);
  }

  resetEspecificRedirectTo(){
    this.removeInteractions();
    this.pointsService.deleteAssessmentProcedureFromMap(this.selectedProcedure);
    let selectedProcedurePointsCopy = cloneDeep(this.selectedProcedure.procedureCoordinatePoints);
    this.selectedProcedure.procedureCoordinatePoints = cloneDeep(this.procedureInterfaceToHTML.procedureCoordinatePoints);

    //let oldProcedureLegs = cloneDeep(this.selectedProcedure.procedureLegs);
    this.selectedProcedure.procedureLegs = cloneDeep(this.procedureInterfaceToHTML.procedureLegs);
    this.updateProcedure(this.selectedProcedure);
    this.pointsService.deleteAssessmentProcedureFromMap(this.selectedProcedure);
    this.selectedProcedure.procedureCoordinatePoints.forEach(currentPCP => {
      const legFound = selectedProcedurePointsCopy.some(pcp2 => pcp2.coordPoint.id == currentPCP.coordPoint.id);
      if (!legFound){
        this.redirectProcedure(currentPCP.coordPoint.id);
      }
    });



  }

  resetRedirectTo(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      this.removeInteractions();
      this.pointsService.deleteAssessmentProcedureFromMap(this.selectedProcedure);
      this.pointsService.deleteCoordinatePointsFromMap();
      await this.pointsService.fetchAndAddCoordinatePoints();
      // preserve coordinates in map, instead of reseting them aswell
      this.selectedProcedure.procedureCoordinatePoints = cloneDeep(this.procedureInterfaceToHTML.procedureCoordinatePoints);
      this.addCoordinatePointFeatures(this.selectedProcedure);
      
      this.selectedProcedure.procedureLegs = cloneDeep(this.procedureInterfaceToHTML.procedureLegs);
      // preserve coordinates in map, instead of reseting them aswell
      for (const oldFixPoint of this.fixPoints){
        let source = this.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === oldFixPoint.coordPoint.type.toLowerCase())
        .olLayer.getSource();
        var feature:Feature = source.getFeatureById(oldFixPoint.coordPoint.id);
        source.removeFeature(feature);
        feature.setProperties({
          'latitude': oldFixPoint.coordPoint.latitude,
          'longitude': oldFixPoint.coordPoint.longitude
        })
        this.pointsService.addCoordinatePointToMap(this.pointsService.transformFeatureInCoordinatePoint(feature), true);
      }

      this.setPointer();
      this.updateProcedure(this.selectedProcedure);

      resolve();
      //});
    })


  }



  async updateOffset(event, isResetAll?: boolean) {

    this.pointsService.deleteAssessmentProcedureFromMap(this.selectedProcedure);
    this.removeInteractions();

    this.pointsService.addProcedureOffSetToMap(this.selectedProcedure).then( function() {
      this.setPointer();
      this.loading = false;
      if (isResetAll){
        this.pointsService.removeProcedureOffSetFromMap();
      }
    }.bind(this));
    this.updateInterfaceProcedure();
    if (isResetAll){
      this.pointsService.removeProcedureOffSetFromMap(this.selectedProcedure);
    }



  }

  async getAzimuthAngle(startPoint, endPoint) : Promise<number> {
    const requestAngle = {
      startPoint: startPoint,
      destPoint: endPoint
    };

    let angle = 0;


    const resp = await this.http
        .post(
          `${this.endpointService.endpointOffset}/getAzimuth`,
          requestAngle,
          this.endpointService.httpOptions
        ).toPromise();

    angle = Number(resp);
    return angle;
  }

  async getCoordinateOffset(coordinatePoint: CoordinatePointModel, offset:number, angle: number, direction: string) : Promise<CoordinatePointModel> {
    const requestOffset = {
      pointToTransform: coordinatePoint,
      offsetValue: offset,
      angle: angle,
      direction: direction,
    };

    let coordinatePointOffset = cloneDeep(coordinatePoint);
    coordinatePointOffset.coordpointid += "_offset";

    const resp = await firstValueFrom(this.http
        .post<coordinatePointTransformationOffsetResult>(
          `${this.endpointService.endpointOffset}/transformCoordOffset`,
          requestOffset,
          this.endpointService.httpOptions
        ));

    coordinatePointOffset.latitude = Number((resp).latitude);
    coordinatePointOffset.longitude = Number((resp).longitude);

    return coordinatePointOffset;
  }

  resetOffsets() {
    this.selectedProcedure.procedureLegs.forEach(leg => {
      leg.direction = "NotSet";
      leg.offset = 0;
    });

    this.pointsService.deleteAssessmentProcedureFromMap(this.selectedProcedure);
    this.pointsService.addProcedureToMap(this.selectedProcedure);
  }

  async applyOffSetToProcedure(procedureToSave: ProcedureModel) : Promise<ProcedureModel>{
    let offsetLegs: ProcedureLegModel [] = [];

    for (let index = 0; index < procedureToSave.procedureLegs.length; index++) {

      const legToOffSet = procedureToSave.procedureLegs[index];

      if (legToOffSet.offset != 0.0 && legToOffSet.direction != "NotSet" && legToOffSet.offset != null && legToOffSet.direction != null) {
        //get angle
        const azimuthAngle = await this.getAzimuthAngle(legToOffSet.startPoint.coordPoint, legToOffSet.endPoint.coordPoint);

        //get offset for starpoint
        const startCPoffset = await this.getCoordinateOffset(legToOffSet.startPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);

        //get offset for endpoint
        const endCPoffset = await this.getCoordinateOffset(legToOffSet.endPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);

        let procOffset = new ProcedureLegModel();
        procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
        procOffset.startPoint.coordPoint = startCPoffset;
        procOffset.endPoint = cloneDeep(legToOffSet.endPoint);
        procOffset.endPoint.coordPoint = endCPoffset;
        if (offsetLegs.length > 0){
          offsetLegs[offsetLegs.length - 1].endPoint = cloneDeep(legToOffSet.startPoint);
          offsetLegs[offsetLegs.length - 1].endPoint.coordPoint = startCPoffset;
        }

        offsetLegs.push(procOffset);

      } else {
        let procOffset = new ProcedureLegModel();
        procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
        procOffset.endPoint = cloneDeep(legToOffSet.endPoint);

        offsetLegs.push(procOffset);
      }

    }

    for (let index = 0; index < procedureToSave.procedureLegs.length; index++){
      if (procedureToSave.procedureLegs[index].direction != "NotSet" && procedureToSave.procedureLegs[index].offset != 0.0
          && procedureToSave.procedureLegs[index].offset != null && procedureToSave.procedureLegs[index].direction != null){

        procedureToSave.procedureLegs[index].startPoint.coordPoint.latitude = Math.round(offsetLegs[index].startPoint.coordPoint.latitude * 100000) / 100000;
        procedureToSave.procedureLegs[index].startPoint.coordPoint.longitude = Math.round(offsetLegs[index].startPoint.coordPoint.longitude * 100000) / 100000;
        procedureToSave.procedureLegs[index].endPoint.coordPoint.latitude = Math.round(offsetLegs[index].endPoint.coordPoint.latitude * 100000) / 100000;
        procedureToSave.procedureLegs[index].endPoint.coordPoint.longitude = Math.round(offsetLegs[index].endPoint.coordPoint.longitude * 100000) / 100000;
        const pcpFromStartPoint = procedureToSave.procedureCoordinatePoints.find(pcp =>
        pcp.coordPoint.id  ==  procedureToSave.procedureLegs[index].startPoint.coordPoint.id);
        const pcpFromEndPoint = procedureToSave.procedureCoordinatePoints.find(pcp =>
        pcp.coordPoint.id  ==  procedureToSave.procedureLegs[index].endPoint.coordPoint.id);
        pcpFromStartPoint.coordPoint.latitude = Math.round(offsetLegs[index].startPoint.coordPoint.latitude * 100000) / 100000;
        pcpFromStartPoint.coordPoint.longitude = Math.round(offsetLegs[index].startPoint.coordPoint.longitude * 100000) / 100000;
        pcpFromEndPoint.coordPoint.latitude = Math.round(offsetLegs[index].endPoint.coordPoint.latitude * 100000) / 100000;
        pcpFromEndPoint.coordPoint.longitude = Math.round(offsetLegs[index].endPoint.coordPoint.longitude * 100000) / 100000;
        this.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id  ==  pcpFromStartPoint.coordPoint.id).coordPoint.ismodified = true;
        this.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id  ==  pcpFromEndPoint.coordPoint.id).coordPoint.ismodified = true;
        procedureToSave.procedureLegs[index].direction = "NotSet";
        procedureToSave.procedureLegs[index].offset = 0.0;
      }
    }
    return procedureToSave;

  }

  public definePointsChanged(procedureToSave: ProcedureModel) : Promise<void> {
    return new Promise(async (resolve, reject) => {
      await this.applyOffSetToProcedure(procedureToSave);
      procedureToSave.procedureCoordinatePoints.forEach(point => {
        const interfacePoint = this.procedureInterfaceToHTML.procedureCoordinatePoints.find(pointInterface =>
          pointInterface.coordPoint.id == point.coordPoint.id);
        if (interfacePoint.coordPoint.ismodified){
          const startPoint = procedureToSave.procedureLegs.find(leg => leg.startPoint.coordPoint.id == interfacePoint.coordPoint.id);
          if (startPoint != undefined){
            startPoint.startPoint.coordPoint = point.coordPoint;
            startPoint.startPointId = undefined;
            startPoint.startPoint.coordPoint.coordpointid = "";
            startPoint.startPoint.coordPoint.name = "";
            startPoint.startPoint.coordPoint.id = undefined;
            startPoint.startPoint.coordPoint.published = false;

          }
          const endPoint = procedureToSave.procedureLegs.find(leg => leg.endPoint.coordPoint.id == interfacePoint.coordPoint.id);
          if (endPoint != undefined){
            endPoint.endPoint.coordPoint = point.coordPoint;
            endPoint.endPointId = undefined;
            endPoint.endPoint.coordPoint.coordpointid = "";
            endPoint.endPoint.coordPoint.name = "";
            endPoint.endPoint.coordPoint.id = undefined;
            endPoint.endPoint.coordPoint.published = false;
          }
        }
      })

      resolve();
    });


  }

  checkIfChange(coordPoint, index: number, isFixPoint?: boolean){
    if (isFixPoint){
      if (Math.round(coordPoint.latitude * 100000) / 100000 != Math.round(this.originalFixPoints[index].coordPoint.latitude * 100000) / 100000 ||
      Math.round(coordPoint.longitude * 100000) / 100000 != Math.round(this.originalFixPoints[index].coordPoint.longitude * 100000) / 100000) {

        coordPoint.ismodified = true;
        this.procedureHasChanged = true;
      } else {
        coordPoint.ismodified = false;
      }
    } else {
      if (Math.round(coordPoint.latitude * 100000) / 100000 != Math.round(this.originalProcedure.procedureCoordinatePoints[index].coordPoint.latitude * 100000) / 100000 ||
      Math.round(coordPoint.longitude * 100000) / 100000 != Math.round(this.originalProcedure.procedureCoordinatePoints[index].coordPoint.longitude * 100000) / 100000) {

        coordPoint.ismodified = true;
        this.procedureHasChanged = true;
      } else {
        coordPoint.ismodified = false;
      }
    }

  }

}
